import React from 'react';
import MaskedInput from 'react-text-mask';
import { StyledTextbox } from '@nib-components/textbox';
import BaseFormField from '../base-form-field';
import { AddFunnelPropFromContext } from '../funnel-context';
import { FUNNELS, LABELS as DEFAULT_LABELS } from '../../util/constants';
import { defaultFieldPropTypes } from '../../types';
const LABELS = {
  ARHI: DEFAULT_LABELS.MEDICARE_CARD_EXPIRY_DATE
};
const MedicareExpiryDate = props => {
  const {
    funnel = FUNNELS.ARHI,
    help = 'MM/YYYY',
    width = 5,
    optional = false,
    required
  } = props;
  return React.createElement(BaseFormField, {
    ...props,
    label: props.label || LABELS[funnel] || LABELS.ARHI,
    funnel: funnel,
    width: width,
    help: help,
    optional: optional,
    required: required
  }, React.createElement(MaskedInput, {
    guide: false,
    mask: [/\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
    ...props.field,
    render: (ref, props) => React.createElement(StyledTextbox, {
      ref: ref,
      ...props
    }),
    autoComplete: "off"
  }));
};
MedicareExpiryDate.defaultProps = {
  ...defaultFieldPropTypes,
  help: 'MM/YYYY',
  width: 5
};
const MedicareExpiryDateWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(MedicareExpiryDate, {
  ...props
}));
export default MedicareExpiryDateWithFunnel;